import { useIntl } from 'react-intl';

export type useFormatMessageParam = {
  id: string;
  values?: {
    [key: string]: string
  }
};

const useFormatMessage = ({id, values} : useFormatMessageParam) : string => {

  const intl = useIntl();

  const message = intl.formatMessage({ id }, values);

  return message;
};

export default useFormatMessage;